<script setup>
// @ts-nocheck
import { ref, onErrorCaptured } from 'vue'
import { useRouter } from 'vue-router'
import logger from '../utils/logger'

const hasError = ref(false)
const error = ref(null)
const router = useRouter()

onErrorCaptured((err, instance, info) => {
  logger.error('ErrorBoundary captured:', err, { info, instanceName: instance?.$options?.name })
  hasError.value = true
  error.value = err
  return false // Prevent further propagation
})

const retry = () => {
  hasError.value = false
  error.value = null
  router.go(0) // Reload the current page
}
</script>

<template>
  <div v-if="hasError" class="min-h-screen flex items-center justify-center bg-brand-background text-brand-text p-4">
    <div class="max-w-md w-full bg-brand-surface border border-brand-border rounded-lg shadow-lg p-6 text-center">
      <div class="mb-4 text-red-500">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      </div>
      <h2 class="text-2xl font-bold mb-2">{{ $t('error.generic_title') }}</h2>
      <p class="text-brand-text-muted mb-6">
        {{ $t('error.generic_message') }}
      </p>
      <div v-if="error && error.message" class="mb-6 p-3 bg-red-900/20 border border-red-900/50 rounded text-left overflow-auto max-h-32 text-sm font-mono text-red-300">
        {{ error.message }}
      </div>
      <button
        @click="retry"
        class="bg-brand-primary hover:bg-brand-primary-hover text-white font-medium py-2 px-6 rounded transition duration-200"
      >
        Reload Page
      </button>
    </div>
  </div>
  <slot v-else></slot>
</template>
